/** Build-time configuration. Nothing here is a secret; the client id is public by design. */
export type AuthMode = 'dev' | 'cognito';

const env = import.meta.env;

export const config = {
  apiUrl: (env.VITE_API_URL as string | undefined) ?? 'http://localhost:4000',
  authMode: ((env.VITE_AUTH_MODE as string | undefined) ?? (env.DEV ? 'dev' : 'cognito')) as AuthMode,
  cognito: {
    region: (env.VITE_COGNITO_REGION as string | undefined) ?? 'us-east-1',
    userPoolId: (env.VITE_COGNITO_USER_POOL_ID as string | undefined) ?? '',
    clientId: (env.VITE_COGNITO_CLIENT_ID as string | undefined) ?? '',
    /** Hosted UI host, e.g. auth.dev.titan.dinocloud.com. Used for the Google redirect only. */
    domain: (env.VITE_COGNITO_DOMAIN as string | undefined) ?? '',
  },
  demoPath: '/demo/index.html',
} as const;

export const appOrigin = (): string => window.location.origin;
